var render, staticRenderFns
import script from "./ColorOfTasks.vue?vue&type=script&lang=js&"
export * from "./ColorOfTasks.vue?vue&type=script&lang=js&"
import style0 from "./ColorOfTasks.vue?vue&type=style&index=0&id=7eb8e4fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eb8e4fc",
  null
  
)

export default component.exports